import baseTheme from '../baseTheme';
var MuiAccordionDetails = {
    root: {
        padding: baseTheme.spacing(2),
        paddingLeft: baseTheme.spacing(4),
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'column',
    },
};
export default MuiAccordionDetails;
//# sourceMappingURL=MuiAccordionDetails.js.map